import React from 'react';
import { useMultiplier } from '../hooks/useMultiplier';
import { formatLilape } from '../config/gameConfig';

export const MultiplierBadge = ({ onUpgradeClick }) => {
  const { balanceTier, vipLevel, totalMultiplier, balance, nextBalanceTier } = useMultiplier();

  return (
    <div style={{
      margin: '0 10px 10px',
      padding: '12px 14px',
      borderRadius: 14,
      background: `linear-gradient(135deg, ${balanceTier.color}15, ${vipLevel.color}10)`,
      border: `1px solid ${balanceTier.color}40`,
    }}>
      {/* Current multiplier */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 40, height: 40, borderRadius: 10,
            background: `linear-gradient(135deg, ${balanceTier.color}30, ${balanceTier.color}15)`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 22,
          }}>
            {balanceTier.icon}
          </div>
          <div>
            <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.5)', marginBottom: 2 }}>
              WIN MULTIPLIER
            </div>
            <div style={{
              fontSize: 22, fontWeight: 900,
              color: balanceTier.color,
              textShadow: `0 0 10px ${balanceTier.color}50`,
            }}>
              x{totalMultiplier.toFixed(1)}
            </div>
          </div>
        </div>

        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>
            {balanceTier.name} Tier
          </div>
          <div style={{ fontSize: 13, fontWeight: 700, color: '#fff' }}>
            {formatLilape(balance || 0)}
          </div>
        </div>
      </div>

      {/* Upgrade prompt */}
      {nextBalanceTier && (
        <div
          onClick={onUpgradeClick}
          style={{
            marginTop: 10,
            padding: '8px 12px',
            borderRadius: 8,
            background: 'rgba(255,255,255,0.05)',
            border: '1px dashed rgba(255,255,255,0.2)',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.6)' }}>
            🚀 Hold <strong style={{ color: '#FFD700' }}>{formatLilape(nextBalanceTier.min)}</strong> for{' '}
            <strong style={{ color: '#10B981' }}>x{nextBalanceTier.mult}</strong>
          </div>
          <div style={{ fontSize: 12, color: '#3B82F6', fontWeight: 700 }}>
            Upgrade →
          </div>
        </div>
      )}

      {/* VIP badge */}
      {vipLevel.level !== 'Member' && (
        <div style={{
          marginTop: 8,
          padding: '6px 10px',
          borderRadius: 6,
          background: `${vipLevel.color}20`,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 6,
        }}>
          <span style={{ fontSize: 14 }}>{vipLevel.icon}</span>
          <span style={{ fontSize: 11, fontWeight: 700, color: vipLevel.color }}>
            {vipLevel.level} VIP
          </span>
          <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.5)' }}>
            +{((vipLevel.multiplier - 1) * 100).toFixed(0)}% bonus
          </span>
        </div>
      )}
    </div>
  );
};

export default MultiplierBadge;
